import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    firstName: '', lastName: '', email: '', mobile: '', address1: '', address2: '', pincode: '',
    fetchedUserInfo: false,
    showProductInfo:false
};


const userInfoSlice = createSlice({
    name: "userInfoSlice",
    initialState,
    reducers: {
        updateLoginInfo: (state, action) => {
            return { ...state, ...action.payload, fetchedUserInfo: true };
        },
        updateInfoAndCloseModal: (state, action) => {
            return { ...state, ...action.payload, fetchedUserInfo: true };
        },
        toggleInfoModal: (state, action) => {
            return { ...state, showProductInfo: action.payload };
        },
        clearUserInfo: () => {
            return initialState;
        },
    },
})

export const { updateLoginInfo, clearUserInfo, updateInfoAndCloseModal, toggleInfoModal } = userInfoSlice.actions;
export default userInfoSlice.reducer;